// TODO: use with all creatives grids
import type CreativeType from '@/Enums/Creatives/CreativeType.enum';
import CreativesTableColumns from '@/Enums/Creatives/CreativesTableColumns.enum';
import type { ILineItemCreative } from '@/Interfaces/CampaignManagement/LineItem.interface';
import { CREATIVE_TYPES_ICONS, CREATIVE_TYPES_TITLES } from '@/constants/creativeLibrary';
import { numberToPercent } from '@/helpers/valueFormatter/numberFormatter.helpers';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { type Moment } from 'moment';

interface IStartEndDate {
  startDate: string | Moment | null;
  endDate: string | Moment | null;
}

export const creativeNameColumn: GridColDef = {
  field: CreativesTableColumns.CREATIVE_NAME,
  headerName: 'Creative Name',
  flex: 2,
  display: 'flex',
};
export const creativeIdColumn: GridColDef = {
  field: CreativesTableColumns.CREATIVE_ID,
  headerName: 'Creative ID',
  flex: 0.5,
  align: 'center',
  display: 'flex',
  valueFormatter: (value: number) => value || '—',
};
export const creativeThumbnailColumn: GridColDef = {
  field: CreativesTableColumns.THUMBNAIL,
  headerName: 'Preview',
  align: 'center',
  headerAlign: 'center',
  flex: 1,
  sortable: false,
  display: 'flex',
};
export const creativeTypeColumn: GridColDef = {
  field: CreativesTableColumns.TYPE,
  headerName: 'Type',
  align: 'center',
  headerAlign: 'center',
  flex: 1.1,
  display: 'flex',
  renderCell: ({ value }: GridRenderCellParams<ILineItemCreative, CreativeType>) => {
    if (!value) return null;
    const Icon = CREATIVE_TYPES_ICONS[value];
    return (
      <div className='flex justify-center items-center'>
        <Icon className={'w-4 mr-1'} />
        <span>{CREATIVE_TYPES_TITLES[value]}</span>
      </div>
    );
  },
};
export const creativePixelsColumn: GridColDef = {
  field: 'thirdPartyPixels',
  sortable: false,
  headerName: '3rd Party Pixels',
  align: 'center',
  flex: 0.9,
};
export const creativeWeightRelColumn: GridColDef = {
  field: 'associationWeightRel',
  sortable: false,
  headerName: 'Relative Weight*',
  align: 'center',
  flex: 0.8,
  display: 'flex',
};
export const creativeWeightPctColumn: GridColDef = {
  field: 'associationWeightPct',
  sortable: false,
  headerName: 'Percentage Weight',
  align: 'center',
  flex: 0.8,
  valueFormatter: (value: number) => numberToPercent(value),
};
export const creativeClickUrlColumn: GridColDef = {
  field: 'clickUrl',
  sortable: false,
  headerName: 'Click Url',
  align: 'center',
  flex: 1.5,
  display: 'flex',
};
export const creativeStartDateColumn: GridColDef = {
  field: 'startDate',
  sortable: false,
  headerName: 'Start Date',
  align: 'center',
  headerAlign: 'center',
  flex: 1.3,
  valueGetter: (_value: unknown, row: ILineItemCreative): IStartEndDate =>
    row ? { startDate: row.startDate, endDate: row.endDate } : { startDate: null, endDate: null },
  display: 'flex',
};
export const creativeEndDateColumn: GridColDef = {
  field: 'endDate',
  sortable: false,
  headerName: 'End Date',
  align: 'center',
  headerAlign: 'center',
  flex: 1.3,
  valueGetter: (_value: unknown, row: ILineItemCreative): IStartEndDate =>
    row ? { startDate: row.startDate, endDate: row.endDate } : { startDate: null, endDate: null },
  display: 'flex',
};
